import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import qs from 'querystringify';

import { Box, Loading, Message } from '../../../components/elements';
import client from '../../../utils/apolloClient';
import Header from './Header';
import Layout from '../../../components/global/Layout';
import LoginTable from './LoginTable';

const placeQuery = gql`
  query fetch_place($placeId: String!) {
    fetch_place(input: { place_id: $placeId }) {
      place_id
      name
      address_line_1
      address_line_2
      city
      state
      country
      post_code
      latitude
      longitude
    }
  }
`;

const View = ({ history, match, location }) => {
  const routeState = qs.parse(location.search);

  const { loading, error, data } = useQuery(placeQuery, {
    variables: { placeId: match.params.placeId },
    client: client.clientPrivate,
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Message>{error.message}</Message>;
  }

  const place = data.fetch_place;

  return (
    <React.Fragment>
      <Header place={place} />
      <Box>
        <LoginTable
          placeId={match.params.placeId}
          routeState={routeState}
          history={history}
        />
      </Box>
    </React.Fragment>
  );
};

const PartnerActivity = props => (
  <Layout>
    <View {...props} />
  </Layout>
);

export default PartnerActivity;
